import React, { useContext } from 'react'
import { NavLink } from "react-router-dom"
import Logo from '../assets/icons/Logo'
import Home from '../assets/icons/Home'
import User from '../assets/icons/User'
import Like from '../assets/icons/Like'
import Help from '../assets/icons/Help'
import Basket from '../assets/icons/Basket'

import MyContext from "./Context/Context";

function Sidebar() {
    const { menu, toggleMenu } = useContext(MyContext);

    return (
        <aside className="sidebar">
            <div className="sidebar__container">
                <NavLink className="sidebar__link" to="/" exact>
                    <Logo />
                </NavLink>
                <NavLink className="sidebar__link" to="/home">
                    <Home />
                </NavLink>
                <NavLink className="sidebar__link" to="/like">
                    <Like />
                </NavLink>
                <a className="sidebar__link" href="#link"
                    onClick={() => toggleMenu(!menu)}
                >
                    <Basket />
                </a>
                <NavLink className="sidebar__link" to="/connect">
                    <User />
                </NavLink>
                <NavLink className="sidebar__link" to="/map">
                    <Help />
                </NavLink>
            </div>
        </aside>
    )
}

export default Sidebar